
(function () {
  'use strict';

  const CELL = '.rendi-partner-value__cell';
  const READY = 'data-rendi-bundle-ready';
  // Stop reserving space when a visible Bundler render stalls or never starts.
  const VISIBLE_BUDGET = 12000;
  const AFTER_LOAD_BUDGET = 3000;

  function formatMoney(cents) {
    const settings = window.Shopify && Shopify.currency_settings;
    const format = (settings && settings.money_format) || window.money_format;
    const found = typeof format === 'string' && format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!found) return null;
    const name = found[1];
    let decimals = name.indexOf('no_decimals') === -1 ? 2 : 0;
    // This format keeps decimals unless the cents are exactly zero.
    if (name === 'amount_no_decimals_if_00') {
      decimals = cents % 100 === 0 ? 0 : 2;
    }
    const comma = name.indexOf('comma_separator') !== -1;
    let group = comma ? '.' : ',';
    if (name.indexOf('space_separator') !== -1) group = ' ';
    if (name.indexOf('apostrophe_separator') !== -1) group = "'";
    const parts = (cents / 100).toFixed(decimals).split('.');
    const units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + group);
    const amount = units + (parts[1] ? (comma ? ',' : '.') + parts[1] : '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function savingInCents(cell) {
    const row = cell.querySelector('.bndlr-total-price');
    if (!row) return 0;
    const was = row.querySelector('.bndlr-old-price[data-currentprice]');
    const now = row.querySelector('.bndlr-new-price[data-currentprice]');
    if (!was || !now) return 0;
    const saving = parseInt(was.getAttribute('data-currentprice'), 10)
      - parseInt(now.getAttribute('data-currentprice'), 10);
    return saving > 0 ? saving : 0;
  }

  function collapse(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  const TRAILING_SEPARATOR = /[\s\u2010-\u2015_|,;:-]+$/;

  function withoutPartner(name, partner) {
    if (!partner || name.length <= partner.length) return name;
    if (name.slice(-partner.length).toLowerCase() !== partner.toLowerCase()) return name;
    return name.slice(0, -partner.length).replace(TRAILING_SEPARATOR, '') || name;
  }

  function paintNames(cell) {
    const partner = collapse(cell.getAttribute('data-rendi-bundle-partner'));
    const pattern = cell.getAttribute('data-rendi-bundle-size-label') || '';
    cell.querySelectorAll('.bndlr-product').forEach(function (tile) {
      const link = tile.querySelector('.bndlr-product-title');
      if (!link) return;
      const name = withoutPartner(collapse(link.getAttribute('title') || link.textContent), partner);
      if (!name) return;
      if (link.textContent !== name) link.textContent = name;
      const select = tile.querySelector('select.bndlr-select-variant');
      if (!select) return;
      const label = pattern.indexOf('__NAME__') === -1 ? name : pattern.replace('__NAME__', name);
      if (select.getAttribute('aria-label') !== label) select.setAttribute('aria-label', label);
    });
  }

  function paintQuantities(cell) {
    const pattern = cell.getAttribute('data-rendi-bundle-quantity') || '';
    if (pattern.indexOf('__COUNT__') === -1) return;
    cell.querySelectorAll('.bndlr-product-quantity[product-quantity]').forEach(function (node) {
      const count = node.getAttribute('product-quantity');
      if (!count) return;
      const text = pattern.replace('__COUNT__', count);
      if (node.textContent !== text) node.textContent = text;
    });
  }

  function paintColumns(cell) {
    const row = cell.querySelector('.bndlr-inner-products-container > div:first-child');
    if (!row) return;
    const count = String(cell.querySelectorAll('.bndlr-product').length);
    if (row.getAttribute('data-rendi-bundle-count') !== count) {
      row.setAttribute('data-rendi-bundle-count', count);
    }
  }

  function paintBadge(cell) {
    const badge = cell.querySelector('[data-rendi-bundle-saving]');
    if (!badge) return;
    const cents = savingInCents(cell);
    const amount = cents > 0 ? formatMoney(cents) : null;
    const template = badge.getAttribute('data-rendi-bundle-saving') || '';
    if (!amount || template.indexOf('__AMOUNT__') === -1) {
      badge.hidden = true;
      return;
    }
    const text = template.replace('__AMOUNT__', amount);
    if (badge.textContent !== text) badge.textContent = text;
    badge.hidden = false;
  }

  const FIELD = '[data-rendi-bundle-field]';
  // The control the customer types in: a field with a key also holds a hidden
  // input for the translated property.
  const CONTROL = 'input:not([type="hidden"]), textarea';
  const fieldsOf = new WeakMap();

  // Kept from the first read: once moved into the app's markup, a re-render
  // can drop a field from the DOM, and the reference brings it back.
  function fields(cell) {
    if (!fieldsOf.has(cell)) {
      fieldsOf.set(cell, Array.prototype.slice.call(cell.querySelectorAll(FIELD)));
    }
    return fieldsOf.get(cell);
  }

  function tilesFor(cell, field) {
    const ids = field.getAttribute('data-rendi-bundle-field');
    return Array.prototype.filter.call(cell.querySelectorAll('.bndlr-product[data-product-id]'), function (tile) {
      return ids.indexOf(' ' + tile.getAttribute('data-product-id') + ' ') !== -1;
    });
  }

  // A field shows only when its product is in this Bundle, right above the
  // app's button. Moved, not cloned, so nothing typed is lost.
  function paintFields(cell) {
    const button = cell.querySelector('.bndlr-add-to-cart');
    if (!button) return;
    fields(cell).forEach(function (field) {
      const used = tilesFor(cell, field).length > 0;
      if (field.hidden === used) field.hidden = !used;
      if (used && field.parentNode !== button.parentNode) button.before(field);
    });
  }

  // The app reads `properties[...]` inputs inside each tile when it adds the
  // Bundle (`getLineItemProperties`), so the value is copied into the tiles of
  // the products that ask for it: the other garments get no property. A field
  // with a key carries two names, `properties[_rendi.<key>]` and the translated
  // label, both with the typed text. Capture phase, so an empty required field
  // stops the click before the app sees it.
  function onAdd(event) {
    if (!event.target.closest('.bndlr-add-to-cart')) return;
    const cell = event.target.closest(CELL);
    if (!cell) return;
    const shown = fields(cell).filter(function (field) { return !field.hidden; });
    for (let i = 0; i < shown.length; i++) {
      const input = shown[i].querySelector(CONTROL);
      // Trimmed first, so `required` also rejects a name made only of spaces.
      input.value = input.value.trim();
      if (!input.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.reportValidity();
        return;
      }
    }
    shown.forEach(function (field) {
      const input = field.querySelector(CONTROL);
      field.querySelectorAll('[name^="properties["]').forEach(function (named) {
        tilesFor(cell, field).forEach(function (tile) {
          let copy = Array.prototype.find.call(tile.querySelectorAll('input[data-rendi-bundle-copy]'), function (node) {
            return node.name === named.name;
          });
          if (!copy) {
            copy = document.createElement('input');
            copy.type = 'hidden';
            copy.name = named.name;
            copy.setAttribute('data-rendi-bundle-copy', '');
            tile.appendChild(copy);
          }
          copy.value = input.value;
        });
      });
    });
  }

  // The app's button is a `div role="button"`: it also adds on Enter and Space,
  // which fire no click.
  function onKey(event) {
    if (event.key === 'Enter' || event.key === ' ') onAdd(event);
  }

  function release(cell) {
    if (!cell.hasAttribute(READY)) cell.setAttribute(READY, '');
  }

  function sync(cell) {
    // Bundler inserts a spinner first; only a product means the card is ready.
    if (cell.querySelector('.bndlr-product')) {
      release(cell);
      paintBadge(cell);
      paintNames(cell);
      paintQuantities(cell);
      paintColumns(cell);
      paintFields(cell);
    }
  }

  const onScreen = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      onScreen.unobserve(entry.target);
      const cell = entry.target;
      setTimeout(function () {
        if (!cell.querySelector('.bndlr-product')) release(cell);
      }, VISIBLE_BUDGET);
    });
  }, { threshold: 0.25 });

  const watched = new WeakMap();

  function start(grid) {
    if (watched.has(grid)) return;
    const run = function () {
      grid.querySelectorAll(CELL).forEach(sync);
    };
    const mutations = new MutationObserver(run);
    mutations.observe(grid, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-currentprice'],
    });
    watched.set(grid, mutations);
    grid.addEventListener('click', onAdd, true);
    grid.addEventListener('keydown', onKey, true);
    run();
    grid.querySelectorAll(CELL).forEach(function (cell) {
      onScreen.observe(cell);
    });
    afterLoad(function () {
      const cells = grid.querySelectorAll(CELL);
      const seen = Array.prototype.some.call(cells, function (cell) {
        const target = cell.querySelector('.bundler-target-element');
        return target && target.hasAttribute('data-bundle');
      });
      if (!seen) cells.forEach(release);
    });
  }

  function afterLoad(fn) {
    if (document.readyState === 'complete') {
      setTimeout(fn, AFTER_LOAD_BUDGET);
      return;
    }
    window.addEventListener('load', function () {
      setTimeout(fn, AFTER_LOAD_BUDGET);
    }, { once: true });
  }

  function stop(grid) {
    const mutations = watched.get(grid);
    if (mutations) {
      mutations.disconnect();
      watched.delete(grid);
    }
    grid.removeEventListener('click', onAdd, true);
    grid.removeEventListener('keydown', onKey, true);
    grid.querySelectorAll(CELL).forEach(function (cell) {
      onScreen.unobserve(cell);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-rendi-partner-value-grid]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-rendi-partner-value-grid]').forEach(stop);
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
